import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { rem } from 'polished';
import styled from 'styled-components';

import { htmlElements } from 'helpers/translations';
import {
  useGetIsCurrentUserAnAdviser,
  useGetIsCurrentUserAPracticeAdmin,
} from 'store/users/selectors';
import GenericButton from 'components/GenericButton/GenericButton';
import BasicModal from 'components/GenericModal/BasicModal';
import { GenericTitle } from 'components/GenericTitle/GenericTitle';
import GenericTitleSummary from 'components/GenericTitleSummary/GenericTitleSummary';
import IconGlitter from 'components/Icons/IconGlitter';

const TextButton = styled.div`
  color: ${({ theme }) => theme.colors.textDark};
  cursor: pointer;
`;

const Title = styled(GenericTitle)`
  display: inline;
`;

const Icon = styled(IconGlitter)`
  margin-left: 0.25em;
  padding-top: 5px;
  transform: scale(0.98) translateY(6px);
`;

function TranscriptionDisclaimerModal({
  enabled,
  toggle,
}: {
  enabled: boolean;
  toggle: () => void;
}) {
  const prev = useRef(false);
  const [isOpen, setOpen] = useState(false);
  const isAdmin = useGetIsCurrentUserAPracticeAdmin();
  const isAdviser = useGetIsCurrentUserAnAdviser();

  const isAuthUser = isAdmin || isAdviser;

  useEffect(() => {
    if (enabled && enabled !== prev.current) {
      setOpen(true);
    }

    prev.current = enabled;
  }, [enabled]);

  const handleConfirm = () => setOpen(false);
  const handleCancel = () => {
    toggle();
    setOpen(false);
  };
  return (
    <BasicModal
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      width={rem(590)}
      shouldCloseOnOverlayClick={false}
    >
      <BasicModal.Title>
        <Title>
          <FormattedMessage id="video.summary.title" />
          <Icon />
        </Title>

        <GenericTitleSummary hasMarginTopSm>
          <FormattedMessage
            id={isAuthUser ? 'video.summary.description' : 'video.summary.clientDescription'}
            values={{ ...htmlElements, br: <br /> }}
          />
        </GenericTitleSummary>
      </BasicModal.Title>

      <BasicModal.Footer>
        <BasicModal.ModalButtons>
          {isAuthUser && (
            <TextButton role="button" onClick={handleCancel}>
              <FormattedMessage id="video.summary.buttonCancel" />
            </TextButton>
          )}

          <GenericButton onClick={handleConfirm} isHalfWidth>
            <FormattedMessage id="video.summary.buttonAction" />
          </GenericButton>
        </BasicModal.ModalButtons>
      </BasicModal.Footer>
    </BasicModal>
  );
}

export default TranscriptionDisclaimerModal;
